import React from 'react';
import {
  useEditableControls,
  Editable,
  EditablePreview,
  EditableInput,
  ButtonGroup,
  IconButton,
  Icon,
  Box,
  Text,
  HStack,
  EditableProps,
} from '@chakra-ui/react';
import { Check, Edit, X } from 'react-feather';

const EditableContent = () => {
  const { isEditing, getSubmitButtonProps, getCancelButtonProps, getEditButtonProps } =
    useEditableControls();

  return (
    <HStack spacing={4} w="100%" align="center" justify="space-between">
      {!isEditing ? <EditablePreview /> : <EditableInput h="44px" w="100%" />}
      <ButtonGroup justifyContent="center" size="sm">
        {isEditing && (
          <IconButton
            h="44px"
            w="44px"
            variant="outline"
            colorScheme="success"
            aria-label="Submit font"
            icon={<Icon as={Check} h="20px" w="20px" />}
            {...getSubmitButtonProps()}
          />
        )}
        {isEditing ? (
          <IconButton
            h="44px"
            w="44px"
            variant="ghost"
            colorScheme="blackAlpha"
            aria-label="Cancel font update"
            icon={<Icon as={X} h="20px" w="20px" />}
            {...getCancelButtonProps()}
          />
        ) : (
          <IconButton
            h="44px"
            w="44px"
            variant="ghost"
            colorScheme="blackAlpha"
            icon={<Icon as={Edit} h="20px" w="20px" />}
            aria-label="Edit font"
            {...getEditButtonProps()}
          />
        )}
      </ButtonGroup>
    </HStack>
  );
};

interface IEditableInputWithButtons extends EditableProps {
  label?: string;
}

export const EditableInputWithButtons = (props?: IEditableInputWithButtons) => {
  const { label, ...rest } = { label: null, ...props };
  return (
    <Box w="100%">
      {label && (
        <Text textStyle="label" fontWeight="bold">
          {label}
        </Text>
      )}
      <Editable {...rest}>
        <EditableContent />
      </Editable>
    </Box>
  );
};
